export default __webpack_public_path__ + "static/starly-c88b6f8e907b7570b68f3ee42846db7a.png";